import symbolName from "@/util/symbol-name.mjs";

export const GAME_SYMBOL_FORTNITE: unique symbol = symbolName("fortnite");
